module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAoCAIAAACn9pfpAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAAAnklEQVQ4T2N89uwZA17ABKVxg1EVqGAYqsjLzz979iyEjQagKUhZWfnfv38JiYmZGRliYmIQOQiAmsHDw/Pz58+ZM2Z4e3svXrz406dPEHEgQHfH06dPy8vLJ02eDOUzMLBAaRiQkpLKyc0NDAiA8uEqvnz5wsbODnJHerq4uDhEEAKgKrx9fGJjY01NTCBcZDCaG1DBqApUQEgFAwMAH0gtC3VZ0pYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/buttons/EXPAND.png
// module id = jMlW
// module chunks = 18